// https://vuex.vuejs.org/en/mutations.html
import axios from "axios";
import state from "./state";
// import moment from 'moment'
// import _ from 'lodash'

export default {
  auth_request(state) {
    state.authStatus = "loading";
  },
  auth_success(
    state,
    {
      tokenWeb,
      usernameWeb,
      userTypeWeb,
      refreshTokenWeb,
      tokenExpDateWeb,
      refreshTokenExpDateWeb,
      changeOldPassFlag,
      acceptTermCondFlag,
    }
  ) {
    state.authStatus = "success";
    state.tokenWeb = tokenWeb;
    state.usernameWeb = usernameWeb;
    state.userTypeWeb = userTypeWeb;
    state.refreshTokenWeb = refreshTokenWeb;
    state.tokenExpDateWeb = tokenExpDateWeb;
    state.refreshTokenExpDateWeb = refreshTokenExpDateWeb;
    state.changeOldPassFlag = changeOldPassFlag;
    state.acceptTermCondFlag = acceptTermCondFlag;
  },
  auth_successRefresh(
    state,
    {
      tokenWeb,
      usernameWeb,
      userTypeWeb,
      refreshTokenWeb,
      tokenExpDateWeb,
      refreshTokenExpDateWeb,
    }
  ) {
    state.authStatus = "success";
    state.tokenWeb = tokenWeb;
    state.usernameWeb = usernameWeb;
    state.userTypeWeb = userTypeWeb;
    state.refreshTokenWeb = refreshTokenWeb;
    state.tokenExpDateWeb = tokenExpDateWeb;
    state.refreshTokenExpDateWeb = refreshTokenExpDateWeb;
  },
  auth_error(state) {
    state.authStatus = "error";
  },
  logoutError(state) {
    state.logoutStatus = "error";
  },
  changeTermCondFlag(state) {
    state.acceptTermCondFlag = true;
  },
  logout(state) {
    state.authStatus = "";
    state.tokenWeb = "";
    state.refreshTokenWeb = "";
    state.tokenExpDateWeb = "";
    state.usernameWeb = "";
    state.userTypeWeb = "";
    state.refreshTokenExpDateWeb = "";
    state.products = [];
    // state.faq = {}

    // state.inquiryFaq = []
    // state.programInfoById = {},
    // state.programInfoInquiry = [],
    // localStorage.removeItem('token')
    // localStorage.removeItem('username')
    // localStorage.removeItem('userType')
    // localStorage.removeItem('refreshToken')
    // localStorage.removeItem('tokenExpDate')
    delete axios.defaults.headers.common["Authorization"];
  },
  setTableList(state, tableList) {
    state.tableList = tableList;
  },
  setUserList(state, userList) {
    state.userList = userList;
  },
  setUser(state, username) {
    state.username = username;
  },
  setUserListCount(state, userListCount) {
    state.userListCount = userListCount;
  },
  userList_error(state) {
    state.userListStatus = "error";
  },
  userListCount_error(state) {
    state.userListCountStatus = "error";
  },
  useradd_error(state) {
    state.userAddStatus = "error";
  },
  useredit_error(state) {
    state.userEditStatus = "error";
  },
  setHeaderLinks(state, headerLinks) {
    state.headerLinks = headerLinks;
  },
  user_error(state) {
    state.userStatus = "error";
  },
  toggleDrawer(state) {
    state.drawer = !state.drawer;
  },
  setShowSnackbar(state, { snackbarMsg, snackbarColor }) {
    state.showSnackbar = true;
    state.snackbarMsg = snackbarMsg;
    state.snackbarColor = snackbarColor;
  },
  setShowDialog(state, { dialogMsg }) {
    state.showDialog = true;
    state.dialogMsg = dialogMsg;
  },
  hideDialog(state) {
    state.showDialog = false;
  },
  resetDialogMsg(state) {
    state.dialogMsg = "";
  },
  hideSnackBar(state) {
    state.showSnackbar = false;
  },
  resetSnackBarMsg(state) {
    state.snackbarMsg = "";
  },
  snackBarColor(state, { color }) {
    state.snackbarColor = color;
  },
  forgotPassSuccess(state) {
    state.forgotPass = "success";
  },
  setPaymentSuccess() {
    state.setPaymentSuccess = "success";
  },
  setCancelOrderSuccess() {
    state.setCancelOrderSuccess = "success";
  },
  changePassSuccess(state) {
    state.changePass = "success";
  },
  setProfile(state, { profileData }) {
    state.profile = profileData;
  },
  setVaProfile(state, { vaProfile }) {
    state.vaProfile = vaProfile;
  },
  resetVaProfile(state) {
    state.profile = {};
  },
  setVaInfo(state, { vaInfoData }) {
    state.vaInfo = vaInfoData;
  },
  resetVaInfo(state) {
    state.vaInfo = {};
  },
  setBankAccInfo(state, { bankAccInfo }) {
    state.bankAccInfo = bankAccInfo;
  },
  setBanks(state, { banks }) {
    state.banks = banks;
  },
  initVaRegistrationSuccess(state) {
    state.initVaRegistration = "success";
  },
  setTitleApp(state, titleApp) {
    state.titleApp = titleApp;
  },
  showRegVaDialog(state, newValue) {
    state.showRegVaDialog = newValue;
  },
  showPopUpNotificationDialog(state, newValue) {
    state.showPopUpNotificationDialog = newValue;
  },
  setFeatures(state, { features }) {
    state.features = features;
  },
  setProductPartners(state, { productPartners }) {
    state.productPartners = productPartners;
  },
  setProducts(state, { products }) {
    state.products = products;
  },
  setJustLoggedIn(state, justLoggedIn) {
    state.justLoggedIn = justLoggedIn;
  },
  setDistTypeList(state, listType) {
    state.distTypeList = listType;
  },
  setDistType(state, type) {
    state.distType = type;
  },
  // setLatest403Page ( state, page) {
  //   state.latest403Page = page
  // },
  addToCart(state, item) {
    // console.log('yang ditambahkan ke item ', item)
    // console.log('isi state terakhir xx', state.cart)
    // state.cart = Object.assign({...state.cart}, item)
    // console.log('statusCode', statusCode)
    let statusCode = Object.values(item)[0].statusCode;
    // console.log('statusCodexxx', [...item])
    // console.log('statusCode', statusCode)
    //update cart list
    let cartListAll = state.cartList;
    cartListAll.all = Object.assign({ ...state.cartList.all }, item);
    if (statusCode === "CIS_DRAFT" || statusCode === "CIS_NEED_OTP")
      cartListAll.draft = Object.assign({ ...state.cartList.draft }, item);
    else if (statusCode === "CIS_NEW")
      cartListAll.new = Object.assign({ ...state.cartList.new }, item);
    // console.log('latest data of cartListAll', cartListAll)
    state.cartList = cartListAll; //Object.assign({...state.cartList}, item )

    state.itemDataCart = item;

    // state.cart = Object.assign(state.cart, {...item})

    // console.log('state cart saat ini ', state.cart)
    //set active itemId for current purchase form
    // state.currItemId = Object.keys(item)
  },
  addToCheckout(
    state,
    { adminFee, checkoutSum, checkoutItems, totalToBePaid }
  ) {
    // console.log('yang ditambahkan ke item ', item)
    // console.log('isi state terakhir xx', state.cart)
    // state.checkout = Object.assign({...state.cart}, item)
    // state.cart = Object.assign(state.cart, {...item})

    // console.log('state cart saat ini ', state.cart)
    //set active itemId for current purchase form
    // state.currItemId = Object.keys(item)

    // setCheckoutItems (state, { checkoutSum, checkoutItems }) {
    // console.log('xxxxxxxxxxxxx', checkoutSum, checkoutItems)
    state.checkoutItems = checkoutItems;
    state.checkoutSum = checkoutSum;
    state.adminFee = adminFee;
    state.totalToBePaid = totalToBePaid;
    // state.adminFeeSum = totalBiayaAdmin
  },
  setViewOrder(
    state,
    {
      orderDetails,
      orderSum,
      orderDetailItems,
      adminFeeSum,
      promoSum,
      totalToBePaidSum,
      programCode,
    }
  ) {
    state.viewOrderdetails = orderDetails;
    state.viewOrderItems = orderDetailItems;
    state.viewOrderSum = orderSum;
    state.adminFeeSum = adminFeeSum;
    state.promoSum = promoSum;
    state.totalToBePaidSum = totalToBePaidSum;
    state.programCode = programCode;
  },
  setViewCart(state, { cartDetails }) {
    state.viewCartdetails = cartDetails;
  },
  setCountNotifUnread(state, { countNotifUnread }) {
    state.countNotifUnread = countNotifUnread;
  },
  resetViewOrder(state) {
    state.viewOrderdetails = {};
    state.viewOrderItems = {};
    state.viewOrderSum = "";
    state.adminFeeSum = 0;
    state.promoSum = 0;
    state.totalToBePaidSum = 0;
  },
  deleteCartItem(state, itemId) {
    let cartItems = state.cartList;
    delete cartItems.new[itemId];

    let cartItemsReward = state.cartListReward;
    delete cartItemsReward[itemId];

    // let itemStatusCode = cartItems.new[itemId].statusCode;

    // delete cartItems.all[itemId];

    // switch (itemStatusCode) {
    //   case "CIS_DRAFT":
    //     delete cartItems.draft[itemId];
    //     break;
    //   case "CIS_NEED_OTP":
    //     delete cartItems.draft[itemId];
    //     break;
    //   case "CIS_NEW":
    //     delete cartItems.new[itemId];
    //     break;
    // }
    state.cartList = Object.assign({}, cartItems);
  },
  moveCartItemJUNK(state, { fromStatus, toStatus, itemId }) {
    let cartItems = state.cartList;
    let itemMoved = {};
    itemMoved[itemId] = cartItems.all[itemId];
    // let itemStatusCode = cartItems.all[itemId].statusCode

    delete cartItems[fromStatus][itemId];
    cartItems[toStatus] = Object.assign({ ...cartItems[toStatus] }, itemMoved);
    state.cartList = Object.assign({}, cartItems);
  },
  deleteCartItems(state, itemIds) {
    // console.log('itemIds', itemIds)
    let cartItems = state.cartList;
    itemIds.forEach((itemId) => {
      let itemStatusCode = cartItems.all[itemId].statusCode;
      delete cartItems.all[itemId];
      switch (itemStatusCode) {
        case "CIS_DRAFT":
          delete cartItems.draft[itemId];
          break;
        case "CIS_NEED_OTP":
          delete cartItems.draft[itemId];
          break;
        case "CIS_NEW":
          delete cartItems.new[itemId];
          break;
        // case 'CIS_ORDERED':
        //   break
      }
    });
    state.cart = Object.assign({}, cartItems);
  },
  resetCart(state) {
    state.cart = {};
    state.cartList = {
      all: "", //cartItems,
      draft: "",
      new: "",
      // ordered: orderedCartItem
    };
    // state.currItemId = ''
  },
  resetCheckoutItems(state) {
    state.checkoutItems = {};
    state.checkoutSum = 0;
    state.adminFee = 0;
    state.totalToBePaid = 0;
  },
  setKtp(state, { ktpData }) {
    state.ktpData = ktpData;
  },
  setInitCurrProduct(state, { initCurrProduct }) {
    state.initCurrProduct = initCurrProduct;
  },
  setInitViewCurrProduct(state, { initViewCurrProduct }) {
    state.initViewCurrProduct = initViewCurrProduct;
  },
  setInitCurrProductRecurr(state, { initCurrProductRecurr }) {
    state.initCurrProductRecurr = initCurrProductRecurr;
  },
  setInitCurrProductHisCert(state, { initCurrProductHisCert }) {
    state.initCurrProductHisCert = initCurrProductHisCert;
  },
  setViewModeReqCert(state, viewModeReqCert) {
    state.viewModeReqCert = viewModeReqCert;
  },
  setCurrOrderSuccess(state, orderSuccessInfo) {
    state.currOrderSuccess = orderSuccessInfo;

    //update state cart
    // let cartItems = state.cart
    // // let checkoutItems = state.checkoutItems
    // Object.keys(state.checkoutItems).forEach(itemId => {
    //   delete cartItems[itemId]
    // })
    // state.cart = Object.assign({}, cartItems)
    this.commit("deleteCartItems", Object.keys(state.checkoutItems)); //must run before commit resetCheckoutItems
    this.commit("resetCheckoutItems");
  },
  setCart(state, { cartItems }) {
    state.cart = cartItems;
  },

  // setCheckoutItems (state, { checkoutSum, checkoutItems }) {
  //   console.log('xxxxxxxxxxxxx', checkoutSum, checkoutItems)
  //   state.checkoutItems = checkoutItems
  //   state.checkoutSum = checkoutSum
  // },
  updateAfterCheckoutCartJUNK(state, itemIds) {
    let cartItems = state.cart;
    itemIds.forEach((itemId) => {
      delete cartItems[itemId];
    });
    state.cart = Object.assign({}, cartItems);
  },
  setTransactionList(state, { transactions, isGroupedByStatus }) {
    if (isGroupedByStatus) {
      // let transStatuses = {
      //   'OS_NEW', 'OS_PAID', 'OS_CANCELED'
      // }
      const newTrans = transactions.filter((trans) => {
        return trans.statusCode === "OS_NEW";
      });

      const paidTrans = transactions.filter((trans) => {
        return trans.statusCode === "OS_PAID";
      });

      const canceledTrans = transactions.filter((trans) => {
        return trans.statusCode === "OS_CANCELED";
      });

      const packing = transactions.filter((trans) => {
        return trans.statusCode === "OS_PACKING";
      });

      state.transactionList = {
        all: transactions,
        new: newTrans,
        paid: paidTrans,
        canceled: canceledTrans,
        packing: packing,
      };
    } else {
      state.transactionList = transactions;
    }
  },
  resetTransactions(state) {
    state.transactions = {};
    state.transactionsNew = {};
    state.transactionsPaid = {};
    state.transactionsCanceled = {};
    state.transactionList = {};
  },
  setTransactions(state, { transactions, status }) {
    // state.transactions[status] = transactions
    // state.transactionsNew = transactions
    // state.transactionsPaid = transactions
    // state.transactionsCanceled = transactions
    // console.log('new state state.transactions ', state.transactions)

    state.transactions = {
      new: status === "OS_NEW" ? transactions : {},
      unpaid: status === "OS_UNPAID" ? transactions : {},
      paid: status === "OS_PAID" ? transactions : {},
      canceled: status === "OS_CANCELED" ? transactions : {},
    };
  },
  // setCartListReward(state, { cartItems }) {
  //   state.cartListReward = cartItems;
  // },
  setCartListReward(state, { cartItems }) {
    state.cartListReward = cartItems.map(item => ({
      productCode: item.productCode,
      productName: item.productName,
      oid: item.oid,
      totalDiscount: item.totalDiscount,
      priceProduct: item.priceProduct,
      price: item.price,
      personName: item.personName,
      quantity: item.quantity,
      pointChange: item.pointChange,
      shoppingDate: item.shoppingDate,
      internalId: item.internalId
    }));
  },  
  // setCartList(state, { cartItems, isGroupedByStatus }) {
  //   if (isGroupedByStatus) {

  //     const statusMap = {
  //       CIS_DRAFT: "draft",
  //       CIS_NEW: "new",
  //       CIS_NEED_OTP: "draft",
  //       // 'CIS_ORDERED': 'ordered' //tidak perlu
  //     };

  //     let cartListAll = {};
  //     const allCartItem = {};
  //     cartItems.forEach((item) => {
  //       let status = statusMap[item["statusCode"]];

  //       if (typeof status !== "undefined") {
  //         if (!cartListAll[status]) cartListAll[status] = {};
  //         if (!cartListAll[status][item["internalId"]])
  //           cartListAll[status][item["internalId"]] = {};
  //         cartListAll[status][item["internalId"]] = item;
  //         allCartItem[item["internalId"]] = item;
  //       }
  //     });

  //     const draftCartItem = cartListAll["draft"] ? cartListAll["draft"] : {};
  //     const newCartItem = cartListAll["new"] ? cartListAll["new"] : {};

  //     state.cartList = {
  //       all: allCartItem, //cartItems,
  //       draft: draftCartItem,
  //       new: newCartItem,
  //       // ordered: orderedCartItem
  //     };
  //   } else {
  //     state.cartList = cartItems;
  //   }
  // },
  setCartList(state, { cartItems, isGroupedByStatus }) {
    if (isGroupedByStatus) {
      const statusMap = {
        CIS_DRAFT: "draft",
        CIS_NEW: "new",
        CIS_NEED_OTP: "draft",
        // 'CIS_ORDERED': 'ordered' // tidak perlu
      };
  
      let cartListAll = {};
      const allCartItem = {};
  
      cartItems.forEach((item) => {
        let status = statusMap[item.statusCode];
  
        if (typeof status !== "undefined") {
          const filteredItem = {
            productCode: item.productCode,
            productName: item.productName,
            oid: item.oid,
            totalDiscount: item.totalDiscount,
            priceProduct: item.priceProduct,
            price: item.price
          };
  
          if (!cartListAll[status]) cartListAll[status] = {};
          cartListAll[status][item.internalId] = filteredItem;
          allCartItem[item.internalId] = filteredItem;
        }
      });
  
      state.cartList = {
        all: allCartItem,
        draft: cartListAll["draft"] || {},
        new: cartListAll["new"] || {}
      };
    } else {
      // Jika tidak grouped, tetap filter field-nya
      state.cartList = cartItems.map(item => ({
        productCode: item.productCode,
        productName: item.productName,
        oid: item.oid,
        totalDiscount: item.totalDiscount,
        priceProduct: item.priceProduct,
        price: item.price
      }));
    }
  },  
  setVaHistory(state, { vaHistoryData }) {
    // let vaHist = {}
    // if(vaHistoryData.length)
    // vaHistoryData.data.forEach((trans) => {
    //   //get date
    //   let transDateTimeRaw = moment(trans.date, 'YYYYMMDDHHmmss')//.format('DD MMM YYYY HH:mm:ss')
    //   let transDate = transDateTimeRaw.format('DD MMM YYYY')
    //   let transTime = transDateTimeRaw.format('HH:mm:ss')
    //   // let xxx = moment.unix(transDate * 1000).format('DD MMM YYYY')
    //   // console.log(moment(transDate, 'DD MMM YYYY').format('x'), xxx)
    //   //let transDateTimeRaw = moment(trans.date, 'YYYYMMDDHHmmss')
    //   if(!vaHist[transDate])
    //     vaHist[transDate] = {}
    //     vaHist[transDate][transTime] = trans
    // })
    // console.log('vaHistxxxxxxxxxxxx', vaHist)
    let latestVaHistory = Object.values({ ...state.vaHistory });
    Array.prototype.forEach.call(vaHistoryData, (n) => {
      // console.log(n)
      latestVaHistory.push(n);
    });
    // vaHistoryData.forEach((n) => {
    //   console.log(n)
    //   latestVaHistory.push(n)
    // })
    // console.log('latestVaHistory', latestVaHistory, 'vaHistoryData', vaHistoryData)
    // let mergeData = {...state.vaHistory, ...vaHistoryData}
    // let mergeData = _.merge(Object.values(latestVaHistory),vaHistoryData)
    // console.log('hasil akhir', mergeData)
    state.vaHistory = latestVaHistory;
    // console.log('vaHistoryData yang baru', vaHistoryData)
    // state.vaHistory = Object.values(latestVaHistory).concat(vaHistoryData)//vaHist
  },
  resetVaHistory(state) {
    state.vaHistory = {};
  },
  downloadEReceiptSuccess(state) {
    state.downloadEReceiptSuccess = "success";
  },
  downloadECertSuccess(state) {
    state.downloadECertSuccess = "success";
  },
  downloadSalesKitAttach(state) {
    state.downloadSalesKitAttachSuccess = "success";
  },
  downloadSalesReportSuccess(state) {
    state.downloadSalesReportSuccess = "success";
  },
  downloadEPolisSuccess(state) {
    state.downloadEPolisSuccess = "success";
  },
  sendEmailPolisSuccess(state) {
    state.sendEmailPolisSuccess = "success";
  },
  startLoading(state) {
    // console.log('im loading now')
    state.isLoading = true;
  },
  stopLoading(state) {
    // console.log('im stop loading now')
    state.isLoading = false;
  },
  setSalesReportList(state, { salesReport }) {
    state.salesReport = salesReport;
  },
  setProductDetails(state, { productDetails }) {
    state.productDetails = productDetails;
  },
  setProductPaymentType(state, { productPaymentTypeList }) {
    state.productPaymentTypeList = productPaymentTypeList;
  },
  setCustomerType(state, { customerTypeList }) {
    state.customerTypeList = customerTypeList;
  },
  setCertSearchKey(state, { certSearchKeyList }) {
    state.certSearchKeyList = certSearchKeyList;
  },
  setCustomerList(state, { customerList }) {
    state.customerList = customerList;
  },
  setSertifikatList(state, { sertifikatList }) {
    state.sertifikatList = sertifikatList;
  },
  setSertifikat(state, { sertifikatInfo }) {
    state.sertifikatInfo = sertifikatInfo;
  },
  setPopupNotifById(state, popupNotifById) {
    state.popupNotifById = popupNotifById;
  },
  setPopupNotif(state, popupNotif) {
    state.popupNotif = popupNotif;
  },
  setReadPopupNotif(state, popupReadNotif) {
    state.popupReadNotif = popupReadNotif;
  },
  setFaqCategoryList(state, faqCategoryList) {
    state.faqCategoryList = faqCategoryList;
  },
  setInquiryFaq(state, inquiryFaq) {
    state.inquiryFaq = inquiryFaq;
  },
  setInquiryFaqWithoutContent(state, inquiryFaqWithoutContent) {
    state.inquiryFaqWithoutContent = inquiryFaqWithoutContent;
  },
  // setFaqById(state, faqById){
  //   state.faqById = faqById
  // },
  setFaq(state, { faq, categoryCode }) {
    state.faq = {
      general: categoryCode === "FC_GENERAL" ? faq : {},
      policy: categoryCode === "FC_E_POLICY" ? faq : {},
      claim: categoryCode === "FC_CLAIM" ? faq : {},
    };
  },
  // setFaqByCategory(state, { faqs, isGroupedByStatus }) {
  //   if (isGroupedByStatus) {
  //     const statusMap = {
  //       'FC_CLAIM': 'claim',
  //       'FC_E_POLICY': 'policy',
  //       'FC_GENERAL': 'general'
  //     }
  //     let cartListAll = {}
  //     const allCartItem = {}
  //     faqs.forEach((item) => {
  //       let kategori = statusMap[item['categoryCode']]
  //       if (typeof kategori !== 'undefined') {
  //         if (!cartListAll[kategori])
  //           cartListAll[kategori] = {}
  //         if (!cartListAll[kategori][item['internalId']])
  //           cartListAll[kategori][item['internalId']] = {}
  //         cartListAll[kategori][item['internalId']] = item
  //         allCartItem[item['internalId']] = item
  //       }
  //     })

  //     const draftCartItem = cartListAll['claim'] ? cartListAll['claim'] : {}
  //     const newCartItem = cartListAll['policy'] ? cartListAll['policy'] : {}
  //     const generalFaq = cartListAll['general'] ? cartListAll['general'] : {}

  //     state.faqList = {
  //       all: allCartItem,//cartItems,
  //       FC_CLAIM: draftCartItem,
  //       FC_E_POLICY: newCartItem,
  //       FC_GENERAL: generalFaq
  //     }
  //   } else {
  //     state.faqList = faqs
  //   }
  // },
  setProgramInfo(state, programInfoInquiry) {
    state.programInfoInquiry = programInfoInquiry;
  },
  setProgramInfoById(state, programInfoById) {
    state.programInfoById = programInfoById;
  },
  setProgramNotif(state, programNotif) {
    state.programNotif = programNotif;
  },
  setReadProgramNotif(state, programReadNotif) {
    state.programReadNotif = programReadNotif;
  },
  setInquirySalesKit(state, inquirySalesKit) {
    state.inquirySalesKit = inquirySalesKit;
  },
  setSalesKitById(state, salesKitById) {
    state.salesKitById = salesKitById;
  },
  setSalesKitItem(state, salesKitItem) {
    state.salesKitItem = salesKitItem;
  },
  setKecamatan(state, kecamatanList) {
    state.kecamatanList = kecamatanList;
  },
  setUserType(state, userTypeListWeb) {
    state.userTypeListWeb = userTypeListWeb;
  },
  setInquiryPromo(state, promoList) {
    state.promoList = promoList;
  },
  resetPromo(state) {
    (state.checkboxItemsChosen = []),
      (state.checkboxItemsChosenDetail = []),
      (state.checkboxItemsChosenDetailPromo = []),
      (state.promoChosen = ""),
      (state.promoChosenName = ""),
      (state.promoChosenCode = ""),
      (state.promoList = []),
      (state.promoTotal = 0);
  },
  setDataRequest(state, data) {
    state.formRequestDealerCash = data;
  },
  setInternalIdCart(state, data) {
    state.internalCartId = data;
  },
  setPremiumResponse(state, data) {
    state.premiumResponse = data;
  },
  setDataInitAdd(state, data) {
    state.dataInitAdd = data;
  },
};
